<template>
  <div>
    <gmap-map :center="center" :zoom="13" style="width:100%;  height: 100vh;">
      <gmap-marker
        v-for="(marker, index) in allMarker"
        :key="index"
        :position="marker.point"
        :icon="{ url: showMarker(marker.type) }"
      >
        <!-- :icon="{ url: marker_icon }" -->
      </gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: 'ViewMapCreateOrUpdate',
  props: ['value'],
  data() {
    return {
      center: { lng: 105.57359185298843, lat: 12.291513194851614 },
      tso: require('@/assets/tso.png'),
      dso: require('@/assets/dso.png')
    }
  },
  created() {
    if (this.value) {
      var locat = this.value.customer_list
      this.center = locat[0]
        ? locat[0].gis_location[0]
        : { lng: 105.57359185298843, lat: 12.291513194851614 }
    }
  },
  computed: {
    showMarker: vm => type => {
      if (type == 'TSO') {
        return vm.tso
      }
      if (type == 'DSO') {
        return vm.dso
      }
      return undefined
    },
    allMarker() {
      if (this.value) {
        if (this.value.customer_list.length) {
          return this.value.customer_list.map(el => ({
            point: el.gis_location ? el.gis_location[0] : undefined,
            type: el.sale_position
          }))
        }

        return []
      }
      return []
    }
  },
  watch: {
    'value.customer_list': {
      handler() {
        if (this.value) {
          var locat = this.value.customer_list
          if (locat.length) {
            this.center = locat[0].gis_location[0]
          }
        }
      },
      deep: true
    }
  }
}
</script>
